import { render, staticRenderFns } from "./folderMat.vue?vue&type=template&id=6e60abfd&scoped=true"
import script from "./folderMat.vue?vue&type=script&lang=js"
export * from "./folderMat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e60abfd",
  null
  
)

export default component.exports